// ✅ US Market Terms of Service - Thin Wrapper (DRY principle)
import TermsPage from '../../sub/terms-of-service';
import SEOHead from '../../../components/SEOHead';

export default function USTerms() {
  return (
    <>
      <SEOHead
        title='Terms of Service | LBVisible'
        description='Terms and conditions for using LBVisible services.'
        keywords='terms of service, terms and conditions, legal'
        canonicalUrl='/us/sub/terms-of-service'
        lang='en'
        hreflang={[
          { hreflang: 'en-GB', href: 'https://www.lbvisible.com/sub/terms-of-service' },
          { hreflang: 'en-US', href: 'https://www.lbvisible.com/us/sub/terms-of-service' },
          { hreflang: 'lt-LT', href: 'https://www.lbvisible.com/lt/sub/naudojimo-taisykles' },
          { hreflang: 'x-default', href: 'https://www.lbvisible.com/sub/terms-of-service' },
        ]}
      />

      <TermsPage />
    </>
  );
}
